export default "__VITE_ASSET__2kfzb40___"